import { Box } from '@mui/material';
import { FC } from 'react';
import { usePermissionsManagerContext } from '../context';
import { Header } from './Header';
import TreeView from './TreeView';

const MainWorkspace: FC = () => {
  const { data } = usePermissionsManagerContext();

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Header />

      <Box sx={{ p: 2, flexGrow: 1, overflowY: 'auto' }}>
        <TreeView data={data} parentPath="" />
      </Box>
    </Box>
  );
};

export default MainWorkspace;
